import React, { useState } from "react";
import { Chip, Menu, MenuItem } from "@mui/material";
import FilterIcon from "@mui/icons-material/FilterAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// A filter on one value out of a list: the QuickFilter chip, filled and reading "Shape: Round" once
// a value is chosen, outlined and reading just "Shape" while it is not. Clicking it opens the
// values; the chip's trailing icon is the caret that opens them, or the cross that clears them.
function ValueFilter({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string | null;
  options: string[];
  onChange: (value: string | null) => void;
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const choose = (option: string | null) => {
    setAnchor(null);
    onChange(option);
  };

  return (
    <>
      <Chip
        label={value ? `${label}: ${value}` : label}
        icon={<FilterIcon fontSize="small" />}
        variant={value ? "filled" : "outlined"}
        clickable
        onClick={(event) => setAnchor(event.currentTarget)}
        onDelete={
          value ? () => onChange(null) : (event) => setAnchor(event.currentTarget)
        }
        deleteIcon={value ? undefined : <ArrowDropDownIcon />}
      />
      <Menu
        anchorEl={anchor}
        open={anchor !== null}
        onClose={() => setAnchor(null)}
      >
        <MenuItem onClick={() => choose(null)}>All</MenuItem>
        {options.map((option) => (
          <MenuItem
            key={option}
            selected={option === value}
            onClick={() => choose(option)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ValueFilter;
